export const MAX_DEFAULT_FIELD_SYMBOLS = 256;

export const MAX_DEFAULT_BIG_FIELD_SYMBOLS = 1024;
